export default __webpack_public_path__ + "media/images/check-white-8e3ae809.svg";